export default "__VITE_ASSET__Dpf34Be7__"